var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Upload',{staticClass:"imageUpload",attrs:{"action":_vm.upLoadURL,"headers":_vm.headers,"data":{
        'src_id': _vm.attForm.src_id,
        'src_name': _vm.attForm.src_name,
        'att_category': 'J1'},"show-upload-list":false,"on-success":_vm.uploaded,"format":_vm.flag == 'img' ? _vm.accept : _vm.accept2,"on-error":_vm.doFailed,"on-format-error":_vm.handleFormatError}},[_c('Button',{attrs:{"id":"upload","icon":"ios-cloud-upload-outline"}},[_vm._v("Upload files")])],1),_vm._v(" "),_c('div',{staticClass:"editor"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79c9096e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dseditor/DsEditor.vue
// module id = null
// module chunks = 